export const iconFontAwesomeAutomotiveMotorcycle = (
	<i className="fa-solid fa-motorcycle"></i>
);
